import config from '../misc/Configuracao';
import fetch from './AxiosAdapter';

interface IStatusRevisaoResponse {
    numero: number;
    codigoMagistrado: string;
    descricao: string;
    cor?: string;
}

class StatusRevisaoPautaApi {

    private get urlBase() {
        return config.urlBaseGE + 'api/status-revisao-pauta';
    }

    async listarPorGabinete(siglaGabinete: string): Promise<IStatusRevisaoResponse[]> {
        const result = await fetch<IStatusRevisaoResponse[]>(`${this.urlBase}?siglaGabinete=${encodeURIComponent(siglaGabinete)}`, {
            method: 'GET',
            cache: 'no-store',
            silent: true,
        });
        return result.data || [];
    }

    async criar(siglaGabinete: string, descricao: string): Promise<IStatusRevisaoResponse[]> {
        const result = await fetch<IStatusRevisaoResponse[]>(`${this.urlBase}/${encodeURIComponent(siglaGabinete)}`, {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
            },
            body: { descricao },
        });
        return result.data || [];
    }

    async criarDefault(siglaGabinete: string): Promise<IStatusRevisaoResponse[]> {
        const result = await fetch<IStatusRevisaoResponse[]>(`${this.urlBase}/${encodeURIComponent(siglaGabinete)}?criarDefault=true`, {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
            },
            silent: true,
        });
        return result.data || [];
    }

    async atualizar(
        siglaGabinete: string,
        numeroStatus: number,
        dados: { descricao?: string; cor?: string },
    ): Promise<IStatusRevisaoResponse> {
        const parametros = new URLSearchParams();
        if (dados.descricao !== undefined) {
            parametros.set('descricao', dados.descricao);
        }
        if (dados.cor !== undefined) {
            parametros.set('cor', dados.cor);
        }

        const result = await fetch<IStatusRevisaoResponse>(
            `${this.urlBase}/${encodeURIComponent(siglaGabinete)}/${numeroStatus}?${parametros.toString()}`,
            {
                method: 'PUT',
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                },
            }
        );
        return result.data;
    }

    async excluir(siglaGabinete: string, numeroStatus: number): Promise<void> {
        await fetch<void>(`${this.urlBase}/${encodeURIComponent(siglaGabinete)}/${numeroStatus}`, {
            method: 'DELETE',
        });
    }
}

export type { IStatusRevisaoResponse };
export default new StatusRevisaoPautaApi();
